import axios from "axios";
import environment from "../environment";

const axiosInstance = axios.create({
  baseURL: environment.baseUrl,
  // baseURL: "http://obektiva-api.test/api",
});

export const request = axiosInstance;
